import { createSlice } from '@reduxjs/toolkit';
import type { StepperInterface } from '@store/stepper/interfaces/stepperInterfaces';

export const initialState: StepperInterface = {
  steps: [],
  activeId: 'step1',
  passSteps: [],
  completed: false,
};

const stepperSlice = createSlice({
  name: 'stepper',
  initialState: initialState,
  reducers: {
    stepsChange(state, action) {
      return {
        ...state,
        steps: action.payload,
      };
    },
    nextStepChange(state, action) {
      if (state.passSteps.indexOf(action.payload) === -1) {
        return {
          ...state,
          activeId: action.payload,
          passSteps: [...state.passSteps, state.activeId],
        };
      }
      return state;
    },
    lastStepChange(state) {
      if (state.passSteps.length > 0) {
        return {
          ...state,
          activeId: state.passSteps[state.passSteps.length - 1],
          passSteps: state.passSteps.slice(0, -1),
        };
      }
      return state;
    },
  },
});

export const { stepsChange, nextStepChange, lastStepChange } =
  stepperSlice.actions;
export const stepperReducer = stepperSlice.reducer;
